import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'exam-event';

const ELEMENTS = define({
  CREATE_BUTTON: ['create', 'button'],
  EXAM_EVENT_NAME_INPUT: ['exam-event-name', 'input'],
  COMPUTER_TYPE: ['computer', 'radio'],
  PAPER_TYPE: ['paper', 'radio'],
  PUBLIC_TYPE: ['public', 'radio'],
  IN_HOUSE_TYPE: ['in-house', 'radio'],
  WEB_REGISTER_METHOD: ['sync-with-wr', 'radio'],
  IMPORT_FILE_METHOD: ['import-file', 'radio'],
  EXAM_COURSE_DROPDOWN: ['exam-course', 'dropdown'],
  EXAM_DATE_INPUT: ['exam-date', 'input'],
  EXAM_START_TIME_INPUT: ['exam-start-time', 'input'],
  EXAM_END_TIME_INPUT: ['exam-end-time', 'input'],
  REGISTRATION_START_DATE_INPUT: ['registration-start-date', 'input'],
  REGISTRATION_END_DATE_INPUT: ['registration-end-date', 'input'],
  PROVINCE_DROPDOWN: ['province', 'dropdown'],
  LOCATION_DROPDOWN: ['location', 'dropdown'],
  ROOM_SELECTION_FORM_FIELD: ['room', 'form-field'],
});

export const EXAM_EVENT_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
